/* eslint-disable @typescript-eslint/naming-convention */
import type { ValidatorTranslation } from '@swf/core/utils/validators';

interface ValidationMessages {
  analytics_tracking_id?: string;
  error_message?: string;
}

export const getErrorMessage = (
  validationMessages: ValidationMessages,
  defaultMessage?: ValidatorTranslation
) => {
  const { analytics_tracking_id, error_message } = validationMessages;
  return analytics_tracking_id && error_message
    ? {
        id: analytics_tracking_id,
        defaultMessage: error_message,
        track: analytics_tracking_id
      }
    : defaultMessage;
};
